import { render, staticRenderFns } from "./AffinityTopBar.vue?vue&type=template&id=3fa0f07e&scoped=true&"
import script from "./AffinityTopBar.vue?vue&type=script&lang=js&"
export * from "./AffinityTopBar.vue?vue&type=script&lang=js&"
import style0 from "./AffinityTopBar.vue?vue&type=style&index=0&id=3fa0f07e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa0f07e",
  null
  
)

export default component.exports